import LegalLayout from "@/pages/LegalLayout";

export default function Datenschutz() {
  return (
    <LegalLayout title="Datenschutzerklärung" testId="datenschutz-page">
      <section>
        <h2 className="font-heading font-semibold text-[#1A1C19] text-lg">1. Verantwortlicher</h2>
        <p className="mt-2">
          LLP Zaun&Garten, Inhaber Anatoli Zygankow, Hummelbecker Str. 18, 32429 Minden,
          Telefon: 0176 41162064, E-Mail: LLP.service@web.de
        </p>
      </section>
      <section>
        <h2 className="font-heading font-semibold text-[#1A1C19] text-lg">2. Erhebung und Verarbeitung von Daten</h2>
        <p className="mt-2">
          Beim Absenden unseres Buchungs- und Kontaktformulars verarbeiten wir die von Ihnen angegebenen Daten
          (Name, E-Mail-Adresse, ggf. Telefonnummer, gewählte Leistung, Wunschtermin und Ihre Nachricht)
          ausschließlich zur Bearbeitung Ihrer Anfrage und zur Terminabstimmung (Art. 6 Abs. 1 lit. b DSGVO).
        </p>
      </section>
      <section>
        <h2 className="font-heading font-semibold text-[#1A1C19] text-lg">3. E-Mail-Versand</h2>
        <p className="mt-2">
          Zur Übermittlung der Benachrichtigungs- und Bestätigungs-E-Mails nutzen wir einen E-Mail-Dienstleister.
          Dabei werden die für den Versand erforderlichen Daten (Empfängeradresse, Inhalt der Nachricht) an diesen
          Dienstleister übermittelt. Eine darüber hinausgehende Weitergabe Ihrer Daten an Dritte erfolgt nicht.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-semibold text-[#1A1C19] text-lg">4. Speicherdauer</h2>
        <p className="mt-2">
          Wir speichern Ihre Anfragedaten nur so lange, wie es für die Bearbeitung Ihrer Anfrage erforderlich ist,
          bzw. solange gesetzliche Aufbewahrungspflichten bestehen. Danach werden die Daten gelöscht.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-semibold text-[#1A1C19] text-lg">5. Kartenmaterial</h2>
        <p className="mt-2">
          Zur Darstellung unseres Standorts binden wir Kartenmaterial von OpenStreetMap ein. Beim Aufruf der Karte
          wird Ihre IP-Adresse an die Server der OpenStreetMap Foundation übertragen. Details finden Sie in der
          Datenschutzerklärung der OpenStreetMap Foundation.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-semibold text-[#1A1C19] text-lg">6. Ihre Rechte</h2>
        <p className="mt-2">
          Sie haben jederzeit das Recht auf Auskunft über Ihre gespeicherten Daten sowie auf Berichtigung,
          Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch (Art. 15–21 DSGVO).
          Wenden Sie sich dazu einfach an die oben genannte E-Mail-Adresse. Zudem haben Sie das Recht, sich bei
          einer Datenschutz-Aufsichtsbehörde zu beschweren.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-semibold text-[#1A1C19] text-lg">7. Hosting</h2>
        <p className="mt-2">
          Diese Website wird bei einem Hosting-Dienstleister betrieben. Beim Aufruf der Seiten werden technisch
          bedingt Zugriffsdaten (z. B. IP-Adresse, Datum und Uhrzeit) verarbeitet, um die Website bereitzustellen
          und deren Sicherheit zu gewährleisten (Art. 6 Abs. 1 lit. f DSGVO).
        </p>
      </section>
      <p className="text-xs text-zinc-400">Stand: Juli 2026</p>
    </LegalLayout>
  );
}
